import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonPurchase() {
  function reportPurchase(
    configId: string | number | undefined,
    productId: string | number,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
    transactionId: string,
  ) {
    pushAxonEvent('purchase', {
      currency: 'USD',
      value: Number(price),
      transaction_id: transactionId,
      items: [buildAxonItem(configId, productId, itemName, price)],
    })
  }

  return { reportPurchase }
}
